import { combineReducers } from '@reduxjs/toolkit'
import { mapPathReducer } from './MapPathSlice'
import { mapGismeteoPrecipitationReducer } from './MapGismeteoPrecipitationSlice'
import { mapRoadWorksWithNormativitiesReducer } from './MapRoadWorksWithNormativitiesSlice'
import { mapWaysideLandLotsReducer } from './MapWaysideLandLotsSlice'
import { mapRepairPlanReducer } from './MapRepairPlan'

export const mapsReducer = combineReducers({
    roadWorksWithNormativities: mapRoadWorksWithNormativitiesReducer,
    path: mapPathReducer,
    gismeteoPrecipitation: mapGismeteoPrecipitationReducer,
    waysideLandLots: mapWaysideLandLotsReducer,
    repairPlan: mapRepairPlanReducer,
    // roadAccidents: mapRoadAccidentsReducer
})